module.exports = __webpack_public_path__ + "img/img5.5d315424.png";